
const $ = window.jQuery;
import Navigo from 'navigo';
import Utils from '../utils/utils';

export default class Router {

  constructor( store ) {

    this.store = store;
    this.initNavigo();
    this.initLinks();
    this.initForms();
    this.initSelects();
    this.isDragging = false;
    this.mouseDownPos = false;

  }
  
  initNavigo() {

    this.navigo = new Navigo(window.GLOBALS.homeUrl, false);
    this.navigo
      .on({
        "*" : () => {
          this.store.trigger( 'router:route' );
        }
      })
      .resolve();
    
  }

  initForms() {
    $(document).on('submit', 'form', (e) => {
      let $form = $(e.target);
      let method = $form.attr('method');
      let action = $form.attr('action');

      if( typeof method === 'undefined' ) {
        method = 'get';
      }
      method = method.toLowerCase();
      if( method !== 'get' ) {
        return true;
      }
      e.preventDefault();
      
      if( typeof action === 'undefined' ) {
        action = window.location.href.split('?')[0];
      }
      var query = $form.serialize();
      var url = `${action}?${query}`;
      this.navigate( url );
    });
  }

  initLinks() {
    this.moveHandler = e => this.onMouseMove(e);
    
    $('html').on('mousedown', e => {
      this.mouseDownPos = {x: e.pageX, y: e.pageY};
      $('html').on('mousemove', this.moveHandler);
    })
    $('html').on('mouseup', e => {
      $('html').off('mousemove', this.moveHandler);
      setTimeout(() => { this.isDragging = false; }, 1);
    })

    $(document).on('click', 'a', (e) => {
      
      if( !this.isRoutableEvent(e) ) {
        return true;
      }
      e.preventDefault();
      if( this.isDragging ) {
        return;
      }
      var $el = $(e.target).closest('a');
      var href = Utils.addTrailingSlash( $el.attr('href') );

      if( !$el.hasClass('history-back') ) {
        this.store.trigger( 'router:forward-link-clicked', href );
      }
      
      this.navigate( href );

    });
  }

  onMouseMove(e) {
    let distX = this.mouseDownPos.x - e.pageX;
    let distY = this.mouseDownPos.y - e.pageY;
    let dist = Math.sqrt(Math.pow(distX, 2) + Math.pow(distY, 2));
    if( dist > 15 ) {
      this.isDragging = true;
    }
  }

  initSelects() {
    $(document).on('change', 'select.route-options', e => {
      let el = e.currentTarget;
      let url = el.options[el.selectedIndex].value;
      this.navigate( url );
    })
  }

  navigate( url, silent = false ) {
    if( silent ) {
      this.navigo.pause();
    }
    
    this.navigo.navigate( url, true );

    if( silent ) {
      this.navigo.resume();
    }
  }

  isPushStateAvailable() {
    return !!(
      typeof window !== 'undefined' &&
      window.history &&
      window.history.pushState
    );
  }

  isRoutableEvent( evt ) {
    
    var $el = $(evt.target);
    var $anchor = $el.closest('a');
    var href = Utils.addTrailingSlash( $.trim( $anchor.attr('href') ) );
    var target = $.trim( $anchor.attr('target') );

    if( !this.isPushStateAvailable() ) {
      return false;
    }

    if(evt.metaKey || evt.ctrlKey || evt.altKey || evt.shiftKey) {
      return false;
    }
    
    if( !$('html').hasClass('is-routing-enabled') ) {
      return false;
    }

    if( href === '#' || href === '##' || href.indexOf('#') === 0 ) {
      return false;
    }

    // internal link?
    if( href.indexOf('//') !== -1 && href.indexOf( Utils.addTrailingSlash( window.GLOBALS.homeUrl ) ) === -1 ) {
      return false;
    }

    if( href.indexOf('/core/') !== -1 ) {
      return false;
    }

    if( target === '_blank' ) {
      return false;
    }

    var isFileLink = /^(http|https):\/\/\S+?\.(gif|zip|jpg|jpeg|pdf|png|mp4|webm|txt)/g.test( href );
    if( isFileLink ) {
      return false;
    }

    var isSpecialLink = /^(mailto:|tel:)/.test( href );
    if( isSpecialLink ) {
      return false;
    }

    var isExternalLink = Utils.isExternalUrl( href );
    if( isExternalLink ) {
      return false;
    }

    var bypassRouter = $anchor.hasClass('bypass-router');
    if( bypassRouter ) {
      return false;
    }

    return true;
    
  }

}
